<template>
  <div class="flex gap-4 h-8 children:skeleton vans:!gap-2">
    <div class="h-4 w-5 md:w-10 vans:<md:w-10" />
    <div class="h-4 w-16" />
    <div class="h-4 w-16 vans:hidden" />
    <div class="h-4 w-12 <md:hidden vans:hidden" />
  </div>
</template>
